const API = "http://vanofeeapi.mdkdesigns.co.uk";
// const API = "https://staging-api.vanoffee.co.uk";
export default API;
